import React, { useState } from "react";
import styled from "styled-components";
import { Badge } from "./Badge.tsx";
import { CountryBadges } from "./CountryBadges.tsx";
import { FloatInput, NumberInput } from "./FloatInput.tsx";
import { HiChevronRight } from "react-icons/hi2";
import { CountryModal, UserModal } from "./UserModal.tsx";
import axiosInstance from "../axiosInstance.tsx";

const MenuWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 40px; /* расстояние между блоками */
  background-color: rgba(255,255,255,0.02);
  padding-left: 14px;
  padding-right: 14px;

`;

const MenuItem = styled.div`
  display: flex;
  padding-top: 14px;
  padding-bottom: 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  flex: 0 0 auto; /* ширина по контенту */
`;

const Header = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: var(--text-color);
  margin-bottom: 4px;
`;

const Content = styled.div`
  font-size: 13px;
  font-weight: 400;
  color: var(--text-color);
  display: flex;
  align-items: center;
  gap: 4px;
`;


const FlagLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  color: gray;
`;

const FlagsContent = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px 12px; /* строки и колонки */
`;





const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  display: none;
`;

const FlagCheckbox = styled.span<{ checked?: boolean }>`
  width: 16px;
  height: 16px;
  border: 1px solid ${({ checked }) => (checked? "gray" : "rgba(31, 31, 31, 1)")};
  border-radius: 4px;
  background-color: rgba(14, 14, 16, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
&:hover {
border-color: gray;
transition: all 0.2s;}

&::after {
  content: '';
  display: block;
  width: 4px;
  height: 8px;
  margin-bottom: 2px;
  border-right: 2px solid white;
  border-bottom: 2px solid white;
  transform: rotate(45deg);
  opacity: ${({ checked }) => (checked ? 1 : 0)};
  transition: opacity 0.2s ease, transform 0.2s ease;
}
`;
const ButtonWithIcon = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px; // расстояние между текстом и иконкой
  padding: 0 4px; // сохранили твою вертикальную обрезку
  border-radius: 6px;
  font-family: 'Onest', sans-serif;
  font-size: 13px;
  font-weight: 500;
  border: none;
  background-color: transparent;
  color: var(--text-active-color);
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;



const Button = styled.button`
  padding: 4px 8px;
  border-radius: 6px;
  font-family: 'Onest', sans-serif;
  padding: 0;
  font-size: 13px;
  font-weight: 500;
  border: none;
  background-color: transparent;
  color: var(--text-active-color);
  cursor: pointer;
`;

type UserMenuProps = {
  countries: string[];
  multiplier: number;
  allGeo: boolean;
  sbGeo: boolean;
  sb: boolean;
  italy: boolean;
  onFlagChange: (flag: "allGeo" | "sbGeo" | "sb" | "italy", value: boolean) => void;

};







export const UserMenu: React.FC<UserMenuProps> = ({
  userId,
  countries,
  multiplier,
  allGeo,
  sbGeo,
  sb,
  italy,
  resourceAccess,
  onResourceAccessChange,
  onFlagChange,
}) => {
    const flags = { allGeo, sbGeo, sb, italy };
    const [isUserModalOpen, setIsUserModalOpen] = React.useState(false);
    const [selectedCountry, setSelectedCountry] = React.useState<string | null>(countries[0]);

  return (
    <MenuWrapper>
                <UserModal onClose={() => setIsUserModalOpen(false)} onResourceAccessChange={onResourceAccessChange} resourceAccess={resourceAccess} userId={userId} selectedCountry={selectedCountry} countries={countries} onCountryChange={setSelectedCountry} isOpen={isUserModalOpen}></UserModal>
      <MenuItem>
        <Header>Страны</Header>
        <Content>
            <CountryBadges countries={countries} onAllClick={() => {
                      setIsUserModalOpen(true);
                  } } onCountryClick={(country) => {setSelectedCountry(country); setIsUserModalOpen(true);}}></CountryBadges>
        </Content>
      </MenuItem>
<MenuItem>
  <Header>Флаги</Header>
  <Content>
  <FlagsContent>
  {[
    { key: 'allGeo', label: 'Продажа всех гео' },
    { key: 'sbGeo', label: 'Продажа СБ по гео' },
    { key: 'sb', label: 'Продажа СБ' },
    { key: 'italy', label: 'Италия в архивах' },
  ].map(({ key, label }) => (
    <FlagLabel key={key}>
      <HiddenCheckbox
        checked={flags[key]}
        onChange={e => onFlagChange(key, e.target.checked)}
      />
      <FlagCheckbox checked={flags[key]} />
      {label}
    </FlagLabel>
  ))}
</FlagsContent>
  </Content>
</MenuItem>

      <MenuItem>
        <Header>Мультипликатор</Header>
        <Content><FloatInput value={multiplier} onChange={(value) => onFlagChange("multiplier", value)} min={0} max={100}/></Content>
      </MenuItem>
      <MenuItem>
        <Header>  <ButtonWithIcon onClick={() => setIsUserModalOpen(true)}>
    Все параметры
    <HiChevronRight size={14} />
  </ButtonWithIcon></Header>

      </MenuItem>
    </MenuWrapper>
  );
};


type CountryMenuProps = {
  flags: {
    acceptDisabled: boolean;
    blocked: boolean;
    forSale: boolean;
  };
  onFlagChange: (key: keyof CountryMenuProps['flags'], value: boolean) => void;
    onCountryDelete: () => void;
  country: object;
};

export const CountryMenu: React.FC<CountryMenuProps> = ({country, flags, onFlagChange, onCountryDelete }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const onDelete = () => {
      setIsModalOpen(false);
      onCountryDelete();

  }


  return (
    <MenuWrapper>
                      <CountryModal onPriceChange={(value) => onFlagChange("price", value)} onDelete={onDelete} onClose={() => setIsModalOpen(false)} isOpen={isModalOpen} country={country} onFlagChange={onFlagChange}></CountryModal>
  
              <div style={{ width: 0, flexShrink: 0 }} />

      <MenuItem>
        <Header>Флаги</Header>
        <Content>
          <FlagsContent>
            {[
              { key: 'enabled', label: 'Включить приемку' },
              { key: 'blocked', label: 'Запрещено' },
              { key: 'for_sell', label: 'На продажу' },
            ].map(({ key, label }) => (
              <FlagLabel key={key}>
                <HiddenCheckbox
                  checked={flags[key]}
                  onChange={e => onFlagChange(key as keyof typeof flags, e.target.checked)}
                />
                <FlagCheckbox checked={flags[key]} />
                {label}
              </FlagLabel>
            ))}
          </FlagsContent>
        </Content>
      </MenuItem>

      <MenuItem>
        <Header>
          <ButtonWithIcon onClick={() => {setIsModalOpen(true)}}>
            Все параметры
            <HiChevronRight size={14} />
          </ButtonWithIcon>
        </Header>
      </MenuItem>
    </MenuWrapper>
  );
};
